import { IQueueActions } from "../../action-types/queue/IQueueActions";
import { IQueueReducer } from "../../reducer-model/queue/IQueueReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const initialState: IQueueReducer = {
    status: eReducerStatusBase.is_not_initialization,
    inQueue: false,
    hasAccess: false,
    position: null,
    estimatedSeconds: null,
    queueSize: null,
    token: null,
    periodClosed: false,
    error_message: "",
    openAt: null,
    closeAt: null,
    enforceTimeWindow: true,
    allowPreviewBeforeOpen: false,
};

export const queueReducer = (state: IQueueReducer = initialState, action: IQueueActions): IQueueReducer => {
    switch (action.type) {
        case "QUEUE_LOAD_STATUS_START":
            return { ...state, status: eReducerStatusBase.is_loading, error_message: "" };
        case "QUEUE_LOAD_STATUS_SUCCESS": {
            const p = action.payload;
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                inQueue: !!p.inQueue,
                hasAccess: !!p.hasAccess,
                position: p.position ?? null,
                estimatedSeconds: p.estimatedSeconds ?? null,
                token: p.token ?? state.token,
                openAt: p.openAt ?? state.openAt,
                closeAt: p.closeAt ?? state.closeAt,
                enforceTimeWindow: p.enforceTimeWindow ?? state.enforceTimeWindow,
                allowPreviewBeforeOpen: p.allowPreviewBeforeOpen ?? state.allowPreviewBeforeOpen,
            };
        }
        case "QUEUE_LOAD_STATUS_ERROR":
            return { ...state, status: eReducerStatusBase.is_error, error_message: action.payload };
        case "QUEUE_SET_POSITION": {
            const p = action.payload;
            return {
                ...state,
                inQueue: !!p.inQueue,
                hasAccess: !!p.hasAccess,
                position: p.position ?? null,
                estimatedSeconds: p.estimatedSeconds ?? null,
                token: p.token ?? state.token,
            };
        }
        case "QUEUE_TICK": {
            const p = action.payload;
            return {
                ...state,
                queueSize: p.queueSize,
                position: state.position != null ? Math.max(0, state.position - p.cleared) : state.position,
                estimatedSeconds:
                    state.position != null
                        ? Math.max(0, Math.ceil((state.position - p.cleared) / 800))
                        : state.estimatedSeconds,
            };
        }
        case "QUEUE_ACCESS_GRANTED":
            return {
                ...state,
                inQueue: false,
                hasAccess: true,
                token: action.payload.token,
                position: null,
                estimatedSeconds: null,
            };
        case "QUEUE_PERIOD_CLOSED":
            return { ...state, periodClosed: true, hasAccess: false, inQueue: false };
        case "QUEUE_PERIOD_OPENED":
            // Reset cờ closed (trường hợp SV vừa rời /closed) + ép status về not_initialization
            // để LandingPage trigger LOAD_STATUS_START lần nữa qua effect, đồng thời saga
            // gọi /queue/status để server cấp QueuePosition mới (ZADD + token).
            return {
                ...state,
                status: eReducerStatusBase.is_not_initialization,
                periodClosed: false,
                error_message: "",
            };
        case "QUEUE_RESET":
            return { ...initialState };
        default:
            return state;
    }
};
